module.exports = __webpack_public_path__ + "static/media/USA.6c05e243.jpg";